// rajesh k 15/12/2022 reusable constants for role access
// Akhila 07/01/2023 field list name change to audit field list

export const EVENT_TRIGGERS = 'Event Triggers';
export const BATCH_TRIGGERS = 'Batch Triggers';
export const ACCOUNT_UPDATE_GROUP = 'Account Update';
export const CLIENT_MAINTENANCE = 'Client Maintenance';
export const CUSTOM_WINDOW = 'Custom Window';
export const CUSTOM_WINDOW_SETUP = 'Custom Window Setup';
export const DATA_CALCULATIONS = 'Data Calculations';
export const DATA_REPOSITORY = 'Data Repository';
export const EXPORT_DATA = 'Exports';
export const FIELD_LIST = 'Audit Field List';
export const FILTER_RULES = 'Filter Rules';
export const IMPORT_DATA = 'Imports';
export const RECORD_FORMAT = 'Record Format';
export const ROLE_MANAGEMENT = 'Role Management';
export const SCHEDULER = 'Scheduler';
export const TRIGGERS_MAINTENANCE = 'Triggers Maintenance';
export const USER_MANAGEMENT = 'User Management';
export const WORK_QUEUE_MAINTENANCE = 'Work Queue Maintenance';
export const WORK_QUEUE_SETUP = 'Work Queue Setup';
export const REPORTING_EXPORT = 'Reporting/Export';
export const LETTER_MAINTENANCE = 'Letter Maintenance';
export const LOOKUP_MAINTENANCE = 'Lookup Maintenance';
export const TRANSLATION_TABLE = 'Translation Tables';
export const CORE_WINDOWS = 'Core Windows';
